import React from 'react'
import logo from 'assets/img/logo.svg'
import { ResetPasswordForm } from 'components'
import { useTranslation } from 'react-i18next'

export const ResetPassword = () => {

    const { t } = useTranslation();

    return (
        <ResetPasswordForm />
    )
}
